<template>
  <div class="padding-xl" v-loading="loading">
    <el-steps :active="2" align-center class="padding-tb-xl" process-status="finish">
      <el-step title="选择订户类型"></el-step>
      <el-step title="填写征订单"></el-step>
      <el-step title="订单支付"></el-step>
      <el-step title="发票开具"></el-step>
    </el-steps>
    <div class="padding-lr shadow-warp">
      <div class="flex justify-between align-center text-lg text-bold">
        <div>
          订单流水号：{{ order.no }}
        </div>
        <div class="padding-tb">应付：<span class="text-red">¥ {{ order.amount }}</span> 元</div>
      </div>
    </div>
    <div class="solid-top padding flex">
      <div class="flex justify-between padding-top-xs">
        <div v-if="order.type==='零散订阅'">零散订阅 - 收件人：{{ order.list[0].addressPerson }}
          联系电话：{{ order.list[0].addressPhone }}
          收件地址：{{ order.list[0].addressProvinceName }}{{
            order.list[0].addressCityName
          }}{{ order.list[0].addressDistrictName }}{{ order.list[0].addressStreet }}
        </div>
        <!--        <div><span class="text-red">¥ {{ order.amount }}</span></div>-->
        <div v-else>集体订阅 - {{ order.community }}</div>
      </div>
    </div>
    <div class="solid-top padding padding-top-xl flex align-center">
    </div>
    <div class="padding padding-top-xl flex align-center">
      <el-radio v-for="(item,index) in payWay" :key="index" v-model="radio" :label="item" @change="changeHandler">
        <div class="padding-left text-center" style="margin-top:-40px">
          <div><img :src="payList[item].icon" width="100" height="50"/></div>
          <div class="padding-top-sm">{{ payList[item].label }}</div>
          <div v-if="payList[item].subLabel" class="text-sm padding-top-sm">{{ payList[item].subLabel }}</div>
        </div>
      </el-radio>
    </div>
    <div class="padding"></div>
    <div v-if="order.invoiceType && order.invoiceType == 2" class=" text-red text-bold">
      已选开批量开多张发票，将依据导入文件中填写的开票信息进行开票
    </div>
    <div v-else-if="!order.invoice || order.invoice.state !== 1" class="solid-top padding flex">
      <div class="padding-top-sm flex justify-start align-end align-center">
        <div class="padding-right-sm">开具发票</div>
        <!--        <el-switch v-model="isRequestInvoice"></el-switch>-->
        <!--        <div v-if="!isRequestInvoice" class="padding-left text-red text-bold">不开票</div>-->
        <div>
          <el-select v-model="isRequestInvoice" placeholder="请选择"
                     :disabled="radio==='invoice' || serverConfig.invoiceForceEnabled === true">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div v-if="isRequestInvoice && order.invoiceType !== 2">
      <el-divider content-position="left"><span class="text-red text-lg">发票信息</span></el-divider>
      <div class="flex justify-start align-center solid-bottom">
        <div class="nav padding-right-xl">
          <div style="cursor:pointer;" class="cu-item text-lg" :class="index==TabCur?'text-red cur':''"
               v-for="(item,index) in tabs" :key="index"
               @click="tabSelect" :data-id="index">
            {{ item }}
          </div>
        </div>
        <div class="padding-left flex justify-start align-end">
          <el-switch v-model="isSaveInvoice"></el-switch>
          <div class="text-sm padding-left-sm">保存为默认发票信息</div>
        </div>
      </div>
      <div class="padding">
        <div class="flex align-center" v-if="serverConfig.invoiceSpecialEnabled===true && TabCur === 0">
          <div class="info-label">
            <div class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
            开票类型：
          </div>
          <div>
            <el-select v-model="invoice.invoiceType" size="small" style="width:197px" placeholder="请选择">
              <el-option label="电子普通发票（数电普票）" value="电子普通发票（数电普票）"></el-option>
              <el-option label="数电专票" value="数电专票"></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex align-center padding-top">
          <div class="flex justify-start align-center">
            <div class="info-label">
              <div class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
              {{ TabCur === 1 ? '姓名' : '单位名称' }}：
            </div>
            <div>
              <el-input v-model="invoice.invoiceOrg" size="small"></el-input>
            </div>
          </div>
          <div v-if="TabCur!==1" class="flex justify-start align-center padding-left-xl">
            <div class="info-label">
              <div class="text-red text-xs"><i class="cuIcon-favor"></i></div>
              税号：
            </div>
            <div>
              <el-input v-model="invoice.invoiceTaxNum" size="small"></el-input>
            </div>
          </div>
        </div>
        <div v-if="TabCur!==2" class="flex align-center padding-top">
          <div class="flex justify-start align-center">
            <div class="info-label">
              <div class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
              接收手机：
            </div>
            <div>
              <el-input v-model="invoice.invoiceReceivePhone" size="small"></el-input>
            </div>
          </div>
          <div class="flex justify-start align-center padding-left-xl">
            <div class="info-label">
              <div class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
              接收邮箱：
            </div>
            <div>
              <el-input v-model="invoice.invoiceMail" size="small"></el-input>
            </div>
          </div>
        </div>
        <div class="flex align-center padding-top" v-if="TabCur!==1">
          <div class="flex justify-start align-center">
            <div class="info-label">
              <div v-if="TabCur===2" class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
              开户银行：
            </div>
            <div>
              <el-input v-model="invoice.invoiceBank" size="small"></el-input>
            </div>
          </div>
          <div class="flex justify-start align-center padding-left-xl">
            <div class="info-label">
              <div v-if="TabCur===2" class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
              银行帐号：
            </div>
            <div>
              <el-input v-model="invoice.invoiceBankAccount" size="small"></el-input>
            </div>
          </div>
        </div>
        <div class="flex align-center padding-top" v-if="TabCur!==1">
          <div class="flex justify-start align-center">
            <div class="info-label">
              <div v-if="TabCur===2" class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
              注册电话：
            </div>
            <div>
              <el-input v-model="invoice.invoicePhone" size="small"></el-input>
            </div>
          </div>
        </div>
        <div class="flex align-center padding-top" v-if="TabCur!==1">
          <div class="flex justify-start align-center">
            <div class="info-label">
              <div v-if="TabCur===2" class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
              注册地址：
            </div>
            <div>
              <el-input v-model="invoice.invoiceOrgAddress" type="textarea" size="small"
                        style="min-width: 400px;"></el-input>
            </div>
          </div>
        </div>
        <div class="flex align-center padding-top">
          <div class="flex justify-start align-center">
            <div class="info-label">发票备注：</div>
            <div>
              <el-input v-model="invoice.invoiceRemark" type="textarea" size="small"
                        style="min-width: 400px;"></el-input>
            </div>
          </div>
        </div>
      </div>
      <div class="padding-lr" v-if="TabCur===2">
        <el-divider content-position="left"><span class="text-red text-lg">发票邮寄信息</span></el-divider>
        <div class="flex align-center padding-top">
          <div class="flex align-center">
            <div class="info-label">
              <div class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
              收件单位：
            </div>
            <div>
              <el-input v-model="invoice.addressOrg" size="small"></el-input>
            </div>
          </div>
          <div class="flex justify-start align-center padding-left-xl">
            <div class="info-label">
              <div class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
              联系电话：
            </div>
            <div>
              <el-input v-model="invoice.addressPhone" size="small"></el-input>
            </div>
          </div>
        </div>
        <div class="flex align-center padding-top">
          <div class="flex justify-start align-center">
            <div class="info-label">
              <div class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
              收件人：
            </div>
            <div>
              <el-input v-model="invoice.addressPerson" size="small"></el-input>
            </div>
          </div>
          <div class="flex justify-start align-center padding-left-xl">
            <div class="info-label">
              <div class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
              邮编：
            </div>
            <div>
              <el-input v-model="invoice.addressZip" size="small"></el-input>
            </div>
          </div>
        </div>
        <div class="flex align-center padding-top">
          <div class="info-label">
            <div class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
            收货地址：
          </div>
          <div>
            <v-region v-model="addressSelected"></v-region>
          </div>
        </div>
        <div class="flex align-center padding-top">
          <div class="flex justify-start align-center">
            <div class="info-label">
              <div class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
              街道：
            </div>
            <div>
              <el-input v-model="invoice.addressStreet" type="textarea" style="min-width: 400px;"
                        size="small"></el-input>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="padding-xl text-center">
      <button v-if="!order.invoice && !order.pay" class="cu-btn bg-red round lg margin-lr" style="width:200px"
              @click="$router.back()">上一步
      </button>
      <button v-if="radio === 'invoice'" class="cu-btn bg-red round lg margin-lr" style="width:200px"
              @click="prepareAskInvoice">
        提前开票
      </button>
      <button v-else class="cu-btn bg-red round lg margin-lr" style="width:200px" @click="pay">
        {{ radio === 'upload' ? '上传汇款凭证' : '支 付' }}
      </button>
    </div>
    <el-dialog title="B2B网银支付" :show-close="false" :close-on-click-modal="false" :visible.sync="b2bVisible">
      <div slot="footer" class="dialog-footer text-center">
        <el-button type="primary" @click="paySuccess">支付成功</el-button>
        <el-button type="primary" @click="rePay">重新支付</el-button>
        <el-button type="primary" @click="cancelB2b">暂不支付</el-button>
      </div>
    </el-dialog>
    <el-dialog title="提前开票申请" :show-close="false" :close-on-click-modal="false" :visible.sync="invoiceVisible">
      <div class="flex justify-start align-center padding-bottom">
        <div class="info-label" style="width: 120px;">
          <div class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
          开票单位名称：
        </div>
        <div>
          <el-input v-model="ask.org" size="small"></el-input>
        </div>
      </div>
      <div class="flex justify-start align-center padding-bottom">
        <div class="info-label" style="width: 120px;">
          <div class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
          经办人：
        </div>
        <div>
          <el-input v-model="ask.person" size="small"></el-input>
        </div>
      </div>
      <div class="flex justify-start align-center padding-bottom">
        <div class="info-label" style="width: 120px;">
          <div class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
          提前开票理由：
        </div>
        <div>
          <el-input type="textarea" v-model="ask.remark" size="small" style="min-width:300px"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="invoiceVisible = false">取消</el-button>
        <el-button type="primary" @click="askInvoice">提交申请</el-button>
      </span>
    </el-dialog>
    <el-dialog title="上传凭证" :show-close="false" :close-on-click-modal="false" :visible.sync="uploadVisible">
      <div class="flex justify-start align-center padding-bottom">
        <div class="info-label">
          <div class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
          汇款帐号：
        </div>
        <div>
          <el-input v-model="payInfo.payAccount" size="small"></el-input>
        </div>
      </div>
      <div class="flex justify-start align-center padding-bottom">
        <div class="info-label">
          <div class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
          汇款人名称：
        </div>
        <div>
          <el-input v-model="payInfo.payOrg" size="small"></el-input>
        </div>
      </div>
      <div class="flex justify-start align-center padding-bottom">
        <div class="info-label">汇款说明：</div>
        <div>
          <el-input type="textarea" v-model="payInfo.payRemark" size="small" style="min-width:300px"></el-input>
        </div>
      </div>
      <div class="flex align-center padding-bottom">
        <div class="flex justify-start align-center">
          <div class="info-label">
            <div class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
            上传凭证：
          </div>
          <div>
            <el-upload
              :class="{uoloadSty:showBtnImg,disUoloadSty:noneBtnImg}"
              :action="getUploadAction()"
              list-type="picture-card"
              :multiple="false"
              :limit="1"
              ref="upload"
              accept="image/jpeg,image/jpg,image/png"
              :auto-upload="false"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :on-change="dealImgChange"
              :on-success="handleUploadSuccess"
              :file-list="fileList">
              <i slot="default" class="el-icon-plus"></i>
            </el-upload>
          </div>
        </div>
      </div>
      <div class="padding-tb-sm flex justify-between align-center">
        <div class="text-red text-lg"><i class="cuIcon-titles"></i>汇款信息</div>
      </div>
      <div>
        <div class="flex justify-start align-center">
          <div class="info-label">账户名称：</div>
          <div>{{ accountInfo.name }}</div>
        </div>
        <div class="flex justify-start align-center">
          <div class="info-label">银行名称：</div>
          <div>{{ accountInfo.bank }}</div>
        </div>
        <div v-if="accountInfo.bankNum!==''" class="flex justify-start align-center">
          <div class="info-label">银行行号：</div>
          <div>{{ accountInfo.bankNum }}</div>
        </div>
        <div class="flex justify-start align-center">
          <div class="info-label">账号：</div>
          <div>{{ accountInfo.account }}</div>
        </div>
        <div v-if="accountInfo.address!==''" class="flex justify-start align-center">
          <div class="info-label">地址电话：</div>
          <div>{{ accountInfo.address }}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="uploadVisible = false">取消</el-button>
        <el-button type="primary" @click="uploadVoucher">上传</el-button>
      </span>
    </el-dialog>
    <el-dialog :show-close="false" :close-on-click-modal="false"
               title="凭证上传成功"
               :visible.sync="uploadDoneVisible"
               width="30%">
      <span>您的汇款凭证已上传成功，请耐心等待我方人员审核，审核通过后可以通过订单查询页面进行发票的开具。</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="uploadDone">我知道了</el-button>
      </span>
    </el-dialog>
    <el-dialog :show-close="false" :close-on-click-modal="false"
               title="开票申请提交成功"
               :visible.sync="invoiceDoneVisible"
               width="30%">
      <span>您的提前开票申请已提交成功，请耐心等待我方人员审核，审核通过后可以通过订单查询页面进行发票的开具。</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="uploadDone">我知道了</el-button>
      </span>
    </el-dialog>
    <el-dialog title="扫码支付" width="340px" class="text-center" :show-close="false" :close-on-click-modal="false"
               :visible.sync="qrCodeVisible">
      <div class="padding-bottom-xl text-xl">支付金额：<span class="text-red">¥ {{ order.amount }}</span></div>
      <vue-qr :text="qrcode.code_url" :margin="0" :size="300"></vue-qr>
      <div slot="footer" class="dialog-footer text-center">
        <el-button type="primary" @click="cancelPay">暂不支付</el-button>
      </div>
    </el-dialog>
    <el-dialog :show-close="false" :close-on-click-modal="false"
               title="单位银行转帐提示"
               :visible.sync="uploadTipShow"
               width="30%">
      <span>汇款凭证审核1-2工作日，订单已填写开票信息的情况下，审核通过后自动开具发票并推送至邮箱</span>
      <br><br>
      <strong style="color: red;">开票信息提交后，系统出票会有延迟，节假日顺延。</strong>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="uploadTipShow = false">我知道了</el-button>
      </span>
    </el-dialog>
    <el-dialog :show-close="false" :close-on-click-modal="false"
               title="提前开票申请提示"
               :visible.sync="askTipShow"
               width="30%">
      <span>先开发票需要1-2个工作日审核，订单已填写开票信息的情况下，审核通过后自动开具发票并推送至邮箱</span>
      <br><br>
      <strong style="color: red;">开票后，请及时汇款，逾期1个月未付款，发票将自动红冲！</strong>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="askTipShow =  false">我知道了</el-button>
      </span>
    </el-dialog>
    <el-dialog :show-close="false" :close-on-click-modal="false"
               title="税号未填写提示"
               :visible.sync="taxDialogShow"
               width="30%">
      <span>确定贵单位无税号？（除部队等特殊单位外，税号为重要必填开票信息）请确认。</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="taxDialogShow = false">去填写</el-button>
        <el-button type="primary" @click="ignoreTaxSubmit">继续提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import bs from '@/services/data/bs'
import config from '../../public/config/config'
import vueQr from 'vue-qr'

export default {
  components: { vueQr },
  name: 'pay',
  data () {
    return {
      imgBaseUrl: config.BASE_URL + '/static',
      serverConfig: config.serverConfig,
      paying: false,
      uploadTipShow: false,
      askTipShow: false,
      accountInfo: config.accountInfo,
      payWay: [],
      payList: {
        wechat: {
          icon: require('@/assets/pay/wechat.jpeg'),
          label: '微信扫码支付'
        },
        alipay: {
          icon: require('@/assets/pay/alipay.jpg'),
          label: '支付宝扫码支付'
        },
        unionpay: {
          icon: require('@/assets/pay/unionpay.jpeg'),
          label: 'B2B银联支付'
        },
        upload: {
          icon: require('@/assets/pay/upload.png'),
          label: '线下单位银行转账',
          subLabel: '上传汇款凭证'
        },
        invoice: {
          icon: require('@/assets/pay/invoice.jpeg'),
          label: '提前开票'
        }
      },
      loading: false,
      radio: config.payWay[0],
      uploadVisible: false,
      invoiceVisible: false,
      uploadDoneVisible: false,
      invoiceDoneVisible: false,
      b2bVisible: false,
      showBtnImg: true,
      noneBtnImg: false,
      limitCountImg: 1,
      qrcode: {
        code_url: ''
      },
      qrCodeVisible: false,
      inttime: 2000,
      payInfo: {
        payAccount: '',
        payOrg: '',
        payRemark: ''
      },
      fileList: [],
      canInvoice: false,
      ask: {
        org: '',
        person: '',
        remark: ''
      },
      isSaveInvoice: true,
      isRequestInvoice: config.serverConfig.invoiceForceEnabled,
      addressSelected: {
        province: '',
        city: '',
        area: '',
        town: ''
      },
      user: {},
      invoice: {
        type: 0,
        invoiceType: '电子普通发票（数电普票）',
        invoiceOrg: '',
        invoiceTaxNum: '',
        invoiceBankAccount: '',
        invoiceBank: '',
        invoiceOrgAddress: '',
        invoicePhone: '',
        invoiceMail: '',
        invoiceRemark: '',
        invoiceReceivePhone: '',
        addressOrg: '',
        addressPhone: '',
        addressArea: '',
        addressStreet: '',
        addressZip: '',
        addressPerson: ''
      },
      tabs: config.invoiceTypes,
      allTabs: config.invoiceTypes,
      TabCur: 0,
      scrollLeft: 0,
      taxDialogShow: false,
      ignoreTaxNum: false,
      options: [{
        value: true,
        label: '开票'
      }, {
        value: false,
        label: '暂不开票'
      }]
    }
  },
  watch: {
    'invoice.invoiceReceivePhone' (val) {
      if (val) {
        val = val.replace(/[^0-9]/ig, '')
        if (val.length > 11) {
          val = val.slice(0, 11)
        }
        this.invoice.invoiceReceivePhone = val
      }
    }
  },
  created () {
    this.order = JSON.parse(sessionStorage.getItem('order'))
    if (this.order && this.order.pay) {
      this.payInfo.id = this.order.pay.id
      this.payInfo.payAccount = this.order.pay.payAccount
      this.payInfo.payOrg = this.order.pay.payOrg
      this.payInfo.payRemark = this.order.pay.payRemark
      this.payInfo.payPic = this.order.pay.payPic
      this.dealImgChange(undefined, [{ url: this.imgBaseUrl + this.order.pay.payPic }])
    }
    if (this.order && this.order.invoiceAsk) {
      this.ask.org = this.order.invoiceAsk.org
      this.ask.person = this.order.invoiceAsk.person
      this.ask.remark = this.order.invoiceAsk.remark
    }
    if (this.order && this.order.subCategory && this.order.subCategory === '单位') {
      this.allTabs = [this.allTabs[0]]
      this.tabs = this.allTabs
    }
    const tmp = []
    this.canInvoice = config.invoiceEnable(this.order)
    for (let i = 0; i < config.payWay.length; i++) {
      if (config.payWay[i] !== 'invoice' || this.canInvoice) {
        tmp.push(config.payWay[i])
      }
    }
    this.payWay = tmp
    if (this.wx_timer) {
      clearInterval(this.wx_timer)
    }
    this.invoice.orderId = this.order.id
    this.user = JSON.parse(sessionStorage.getItem('user'))
    if (this.order.list && this.order.list.length > 0) {
      const firstDetail = this.order.list[0]
      if (firstDetail.invoiceOrg) {
        this.invoice.invoiceOrg = firstDetail.invoiceOrg
      }
      if (firstDetail.invoiceTaxTin) {
        this.invoice.invoiceTaxNum = firstDetail.invoiceTaxTin
      }
      if (firstDetail.invoicePhone) {
        this.invoice.invoiceReceivePhone = firstDetail.invoicePhone
      }
      if (firstDetail.invoiceEmail) {
        this.invoice.invoiceMail = firstDetail.invoiceEmail
      }
    } else if (this.user) {
      this.invoice.addressOrg = this.user.addressOrg
      this.invoice.addressPhone = this.user.addressPhone
      this.invoice.addressStreet = this.user.addressStreet
      this.invoice.addressZip = this.user.addressZip
      this.invoice.addressPerson = this.user.addressPerson
      if (this.user.addressArea) {
        this.invoice.addressArea = this.user.addressArea
        const areas = this.user.addressArea.split(',', -1)
        this.addressSelected.province = areas[0]
        this.addressSelected.city = areas[1]
        this.addressSelected.area = areas[2]
      }
      this.invoice.invoiceOrg = this.user.invoiceOrg
      this.invoice.invoiceTaxNum = this.user.invoiceTaxNum
      this.invoice.invoiceBankAccount = this.user.invoiceBankAccount
      this.invoice.invoiceBank = this.user.invoiceBank
      this.invoice.invoiceOrgAddress = this.user.invoiceOrgAddress
      this.invoice.invoicePhone = this.user.invoicePhone
      this.invoice.invoiceMail = this.user.invoiceMail
      this.invoice.invoiceReceivePhone = this.user.invoiceReceivePhone
    }
  },
  methods: {
    tabSelect (e) {
      this.TabCur = parseInt(e.currentTarget.dataset.id)
      this.scrollLeft = (e.currentTarget.dataset.id - 1) * 60
      this.invoice.invoiceType = (this.TabCur !== 2 ? '增值税普通电子发票' : '专票')
      this.invoice.type = this.TabCur
    },
    changeHandler (val) {
      if (config.TIP_SHOW) {
        if (val === 'upload') {
          this.uploadTipShow = true
        } else if (val === 'invoice') {
          this.askTipShow = true
        }
      }
      if (val === 'invoice') {
        this.isRequestInvoice = true
        this.tabs = [this.allTabs[0]]
      } else {
        this.tabs = this.allTabs
      }
    },
    prepareAskInvoice () {
      if (!this.checkRequestInvoice()) {
        this.$message.error('提前开票必须填选择开具发票！')
        return false
      }
      if (this.validAskInvoiceForm()) {
        if (this.TabCur !== 1 && (!this.invoice.invoiceTaxNum || this.invoice.invoiceTaxNum.trim() === '') && !this.ignoreTaxNum) {
          this.taxDialogShow = true
        } else {
          this.invoiceVisible = true
        }
      }
    },
    askInvoice () {
      if (this.ask.org.trim() === '') {
        this.$message.error('请填写开票单位名称！')
        return false
      }
      if (this.ask.person.trim() === '') {
        this.$message.error('请填写经办人！')
        return false
      }
      if (this.ask.remark.trim() === '') {
        this.$message.error('请填写理由！')
        return false
      }
      this.saveAskInvoice()
    },
    ignoreTaxSubmit () {
      this.taxDialogShow = false
      this.ignoreTaxNum = true
    },
    saveAskInvoice () {
      bs.order.askInvoice(this.order.id, this.ask, (res) => {
        if (res.code === 200) {
          this.invoice.addressArea = this.addressSelected.province + ',' + this.addressSelected.city + ',' + this.addressSelected.area
          bs.order.invoice(this.order.id, this.isSaveInvoice, this.invoice, (res) => {
            if (res.code === 200) {
              this.invoiceDoneVisible = true
            }
          })
        }
      })
    },
    setWxTimer () {
      clearInterval(this.wx_timer)
      this.wx_timer = setInterval(() => {
        bs.order.queryPay(this.order.id, (res) => {
          if (res.code === 200) {
            if (this.wx_timer) {
              clearInterval(this.wx_timer)
            }
            this.qrCodeVisible = false
            this.$message({
              message: '支付成功！',
              type: 'success'
            })
            this.nextStep()
          }
        })
      }, this.inttime)

      clearInterval(this.wx_close_timer)
      this.wx_close_timer = setInterval(() => {
        this.qrCodeVisible = false
      }, 10 * 60 * 1000)
    },
    delPay () {
      // bs.order.delPay(this.order.id, (res) => {
      //   if (res.code === 200 && res.data && res.data === 0) {
      //     this.$message({
      //       message: '支付成功！',
      //       type: 'success'
      //     })
      //     this.nextStep()
      //   }
      // })
    },
    cancelPay () {
      this.qrCodeVisible = false
      this.delPay()
      if (this.wx_timer) {
        clearInterval(this.wx_timer)
      }
      if (this.wx_close_timer) {
        clearInterval(this.wx_close_timer)
      }
      this.paying = false
    },
    cancelB2b () {
      this.b2bVisible = false
      this.queryB2b(this.b2bPaySuccess)
    },
    queryB2b (success, failed) {
      bs.order.b2bQuery(this.order.id, (res) => {
        if (res.code === 200) {
          if (success) {
            success()
          }
        } else {
          if (failed) {
            failed()
          }
        }
      })
    },
    paySuccess () {
      this.queryB2b(this.b2bPaySuccess, () => {
        this.$message.error('您还没有完成支付！')
      })
    },
    b2bPaySuccess () {
      this.$message({
        message: '支付成功！',
        type: 'success'
      })
      this.nextStep()
    },
    rePay () {
      this.queryB2b(this.b2bPaySuccess, () => {
        setTimeout(this.b2bPay, 0)
      })
    },
    b2bPay () {
      if (this.checkRequestInvoice() && this.validAskInvoiceForm()) {
        if (this.TabCur !== 1 && (!this.invoice.invoiceTaxNum || this.invoice.invoiceTaxNum.trim() === '') && !this.ignoreTaxNum) {
          this.taxDialogShow = true
        } else {
          if (this.paying) {
            return false
          } else {
            // if (this.isRequestInvoice)
            this.paying = true
            this.invoice.addressArea = this.addressSelected.province + ',' + this.addressSelected.city + ',' + this.addressSelected.area
            bs.order.invoice(this.order.id, this.isSaveInvoice, this.invoice, (res) => {
              if (res.code === 200) {
                this.b2bVisible = true

                if (config.B2B_V2 === true) {
                  bs.order.b2b(this.order.id, (res) => {
                    if (res.code === 200) {
                      window.open(res.data, '_blank')
                      this.paying = false
                    }
                  })
                } else {
                  window.open('/b2b.html?p=' + this.order.id, '_blank')
                  this.paying = false
                }
              }
            })
          }
        }
      } else if (this.isRequestInvoice === false) {
        if (this.paying) {
          return false
        } else {
          this.paying = true
          this.b2bVisible = true

          if (config.B2B_V2 === true) {
            bs.order.b2b(this.order.id, (res) => {
              if (res.code === 200) {
                window.open(res.data, '_blank')
                this.paying = false
              }
            })
          } else {
            window.open('/b2b.html?p=' + this.order.id, '_blank')
            this.paying = false
          }
        }
      }
      // this.b2bVisible = true
      //
      // if (config.B2B_V2 === true) {
      //   bs.order.b2b(this.order.id, (res) => {
      //     if (res.code === 200) {
      //       window.open(res.data, '_blank')
      //     }
      //   })
      // } else {
      //   window.open('/b2b.html?p=' + this.order.id, '_blank')
      // }
    },
    wechatPay () {
      if (this.checkRequestInvoice() && this.validAskInvoiceForm()) {
        if (this.TabCur !== 1 && (!this.invoice.invoiceTaxNum || this.invoice.invoiceTaxNum.trim() === '') && !this.ignoreTaxNum) {
          this.taxDialogShow = true
        } else {
          if (this.paying) {
            return false
          } else {
            // if (this.isRequestInvoice)
            this.paying = true
            this.invoice.addressArea = this.addressSelected.province + ',' + this.addressSelected.city + ',' + this.addressSelected.area
            bs.order.invoice(this.order.id, this.isSaveInvoice, this.invoice, (res) => {
              if (res.code === 200) {
                bs.order.pay(this.order.id, (res) => {
                  if (res.code === 200) {
                    if (res.data === '订单已支付') {
                      this.$message.info('订单已支付')
                      this.nextStep()
                    } else {
                      this.qrcode = JSON.parse(res.data)
                      this.qrCodeVisible = true
                      this.setWxTimer()
                    }
                  }
                  this.paying = false
                }, () => {
                  this.paying = false
                })
              }
            })
          }
        }
      } else if (this.isRequestInvoice === false) {
        if (this.paying) {
          return false
        } else {
          this.paying = true
          bs.order.pay(this.order.id, (res) => {
            if (res.code === 200) {
              this.qrcode = JSON.parse(res.data)
              this.qrCodeVisible = true
              this.setWxTimer()
            }
            this.paying = false
          }, () => {
            this.paying = false
          })
        }
      }
    },
    aliPay () {
      this.wechatPay()
    },
    uploadPay () {
      if (this.checkRequestInvoice()) {
        if (this.validAskInvoiceForm()) {
          if (this.TabCur !== 1 && (!this.invoice.invoiceTaxNum || this.invoice.invoiceTaxNum.trim() === '') && !this.ignoreTaxNum) {
            this.taxDialogShow = true
          } else {
            this.uploadVisible = true
          }
        }
      } else {
        this.uploadVisible = true
      }
    },
    dealImgChange (file, fileList) {
      this.noneBtnImg = fileList.length >= this.limitCountImg
      this.showBtnImg = !this.noneBtnImg
      this.fileList = fileList
    },
    pay () {
      if (this.isRequestInvoice === undefined) {
        this.$message.error('请选择是否开具发票！')
        return false
      }
      if (this.radio === 'wechat') {
        this.wechatPay()
        // this.$message.error('微信支付稍后开通，请选择其他两种支付方式！')
      } else if (this.radio === 'alipay') {
        this.aliPay()
      } else if (this.radio === 'unionpay') {
        this.b2bPay()
      } else if (this.radio === 'upload') {
        this.uploadPay()
      }
    },
    nextStep () {
      this.$router.push({ path: '/pages/order-list' })
      // this.$router.push({ path: '/pages/subscribe/invoice' })
    },
    handleRemove (file, fileList) {
      delete this.payInfo.payPic
      this.noneBtnImg = fileList.length >= this.limitCountImg
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    getUploadAction () {
      return config.BASE_URL + '/api/1.0/order/pay/upload/' + this.order.id
    },
    uploadVoucher () {
      if (this.fileList.length === 0) {
        this.$message.error('请选择凭证文件！')
        return false
      }
      if (this.payInfo.payAccount.trim() === '') {
        this.$message.error('汇款帐号不能为空！')
        return false
      }
      if (this.payInfo.payOrg.trim() === '') {
        this.$message.error('汇款人名称不能为空！')
        return false
      }

      this.loading = true
      this.$refs.upload.submit()
      this.uploadVisible = false
    },
    handleUploadSuccess (res) {
      this.fileList = []
      delete this.payInfo.payPic
      if (res.code === 200) {
        this.uploadDoneVisible = true
        const payId = res.data
        if (this.checkRequestInvoice()) {
          bs.order.invoice(this.order.id, this.isSaveInvoice, this.invoice, (res) => {
            if (res.code === 200) {
              bs.order.saveVoucher(payId, this.payInfo, (res) => {
              })
            }
          })
        } else {
          bs.order.saveVoucher(payId, this.payInfo, (res) => {
          })
        }
      }
    },
    uploadDone () {
      this.uploadDoneVisible = false
      this.invoiceDoneVisible = false
      this.$router.push({ path: '/pages/order-list' })
    },
    checkRequestInvoice () {
      return this.isRequestInvoice || this.order.invoiceType === 2
    },
    validAskInvoiceForm () {
      if (this.order.invoiceType === 2) {
        return true
      }
      if (this.invoice.invoiceOrg) {
        this.invoice.invoiceOrg = this.invoice.invoiceOrg.replaceAll(' ', '')
      }
      if (!this.invoice.invoiceOrg || this.invoice.invoiceOrg.trim() === '' || this.invoice.invoiceOrg.indexOf(':') !== -1 || this.invoice.invoiceOrg.indexOf('：') !== -1) {
        this.$message.error('发票信息-请输入正确的' + (this.TabCur === 1 ? '姓名' : '单位名称'))
        return false
      }
      if (this.TabCur !== 2) {
        if (this.invoice.invoiceTaxNum) {
          this.invoice.invoiceTaxNum = this.invoice.invoiceTaxNum.replaceAll(' ', '')
        }
        if (/[\u4e00-\u9fa5]/.test(this.invoice.invoiceTaxNum)) {
          this.$message.error('发票信息-请输入正确的税号')
          return false
        }
        if (!this.invoice.invoiceReceivePhone || this.invoice.invoiceReceivePhone.trim() === '' || this.invoice.invoiceReceivePhone.trim().length !== 11 || !this.invoice.invoiceReceivePhone.startsWith('1')) {
          this.$message.error('发票信息-请输入正确的手机号码')
          return false
        }
        if (!this.invoice.invoiceMail || this.invoice.invoiceMail.trim() === '' || !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(this.invoice.invoiceMail)) {
          this.$message.error('发票信息-请输入正确的接收邮箱')
          return false
        }
      } else {
        if (!this.invoice.invoiceBank || this.invoice.invoiceBank.trim() === '') {
          this.$message.error('发票信息-开户银行不能为空')
          return false
        }
        if (!this.invoice.invoiceBankAccount || this.invoice.invoiceBankAccount.trim() === '') {
          this.$message.error('发票信息-银行帐号不能为空')
          return false
        }
        if (!this.invoice.invoicePhone || this.invoice.invoicePhone.trim() === '') {
          this.$message.error('发票信息-注册电话不能为空')
          return false
        }
        if (!this.invoice.invoiceOrgAddress || this.invoice.invoiceOrgAddress.trim() === '') {
          this.$message.error('发票信息-注册地址不能为空')
          return false
        }
        if (!this.invoice.addressOrg || this.invoice.addressOrg.trim() === '') {
          this.$message.error('发票信息-收件单位不能为空')
          return false
        }
        if (!this.invoice.addressPhone || this.invoice.addressPhone.trim() === '') {
          this.$message.error('发票信息-联系电话不能为空')
          return false
        }
        if (!this.invoice.addressPerson || this.invoice.addressPerson.trim() === '') {
          this.$message.error('发票信息-收件人不能为空')
          return false
        }
        if (!this.invoice.addressZip || this.invoice.addressZip.trim() === '') {
          this.$message.error('发票信息-邮编不能为空')
          return false
        }
        if (this.addressSelected.area.trim() === '' || this.addressSelected.area === null) {
          this.$message.error('发票信息-收货地址请选到区县')
          return false
        }
        if (!this.invoice.addressStreet || this.invoice.addressStreet.trim() === '') {
          this.$message.error('发票信息-街道不能为空')
          return false
        }
      }
      return true
    }
  }
}
</script>

<style>
.info-label {
  width: 100px;
  padding: 2px 0;
  text-align: right;
  display: flex;
  justify-content: flex-end;
}

.info-label div {
  padding-top: 3px;
  padding-right: 2px;
}

.disUoloadSty .el-upload--picture-card {
  display: none !important;
}
</style>
